import identity from "ramda/es/identity";
import { reduxActionWindowEvent } from '../constants';
export const apmReduxMiddleware = (actionTransformer = identity)=>()=>(next)=>(action)=>{
                if (window && action?.type) {
                    window.dispatchEvent(new CustomEvent(reduxActionWindowEvent, {
                        detail: actionTransformer(action)
                    }));
                }
                return next(action);
            };
